export function navigateExternalNoReferrer(
  href: string,
  {
    newTab,
    extraParams,
  }: { newTab: boolean; extraParams?: URLSearchParams | string },
) {
  const url = new URL(href, window.location.origin);

  if (extraParams) {
    const searchParams =
      typeof extraParams === 'string'
        ? new URLSearchParams(extraParams)
        : extraParams;

    searchParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });
  }

  const finalUrl = url.toString();

  try {
    if (window.top && window.top !== window.self) {
      if (newTab) {
        window.top.open(finalUrl, '_blank', 'noreferrer');
      } else {
        window.top.location.href = finalUrl;
      }
      return;
    }
  } catch (e) {
    console.warn('[navigateExternalNoReferrer] fallback para âncora', e);
  }

  const a = document.createElement('a');
  a.href = finalUrl;
  a.rel = newTab ? 'noreferrer noopener' : 'noreferrer';
  (a as any).referrerPolicy = 'no-referrer';
  a.target = newTab ? '_blank' : '_self';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
